import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { OlPdfAcceptanceComponent } from 'src/app/components/ol-pdf-acceptance/ol-pdf-acceptance.component';
import {
  OfferPdfPreviewModalComponent,
  OfferPdfPreviewResult,
} from 'src/app/components/offer-pdf-preview-modal/offer-pdf-preview-modal.component';
import { OlFeatureFlagsService } from 'src/app/services/ol-feature-flags.service';
import { PdfService } from 'src/app/services/pdf.service';

@Component({
  selector: 'hr-offer-preview-fab',
  templateUrl: './offer-preview-fab.component.html',
  styleUrls: ['./offer-preview-fab.component.scss'],
})
export class OfferPreviewFabComponent implements OnInit {
  @ViewChild('olPdfAcceptance')
  olPdfAcceptance!: OlPdfAcceptanceComponent;
  @Output() nextSlideEmitter = new EventEmitter<number | void>();

  isGenerating = false;
  showFab$: Observable<boolean>;

  constructor(
    private dialog: MatDialog,
    private pdfService: PdfService,
    private featureFlagsService: OlFeatureFlagsService
  ) {}

  ngOnInit(): void {
    this.showFab$ = this.featureFlagsService.getShowPdfProposalPreview$();
  }

  async openPreview(): Promise<void> {
    if (this.isGenerating) return;

    this.isGenerating = true;
    try {
      const blob = await this.pdfService.convertToBlob(this.olPdfAcceptance);

      this.dialog
        .open(OfferPdfPreviewModalComponent, {
          panelClass: ['hr-modal', 'hr-offer-pdf-preview-modal'],
          backdropClass: 'hr-modal-backdrop-close',
          data: { blob },
        })
        .afterClosed()
        .subscribe((result?: OfferPdfPreviewResult) => {
          if (result) {
            this.nextSlideEmitter.emit(result.nextSlideEvent);
          }
        });
    } finally {
      this.isGenerating = false;
    }
  }
}
